import React from 'react';
import { Tooltip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { isNumber } from 'lodash/fp';
import { usePriceService } from '../../../../utils/hooks/priceService';
import { ColoredCard } from '../style';
import { CardContent, Typography } from '../../../../ui-kit';
import { useUser } from '../../../../utils/hooks/auth';
import { TopCategories } from '../../../../generated/graphql';
import { generateTranslationByVenueType } from '../../../../utils';
import { IncompleteDataDisclaimer } from '../../../shared';

const TopCategoryCard = ({ name, quantity, totalPriceSold, color, netMargin, foodCost, productWithNoRecipeCount }: TopCategories) => {
    const { priceService } = usePriceService();
    const { t } = useTranslation();
    const { user: { defaultCurrency: { currencyCode }, venueType } } = useUser();

    return (
        <ColoredCard color={color || undefined} fullHeight>
            <CardContent padding={2}>
                <Tooltip title={name} aria-label={name} placement='top'>
                    <div>
                        <Typography variant='h5' gutterBottom noWrap>{name}</Typography>
                    </div>
                </Tooltip>
                <Typography variant='caption' color='textSecondary'>{t('Gross revenue')}</Typography>
                <Typography variant='body2' gutterBottom>{priceService.toLocaleString(totalPriceSold, currencyCode)}</Typography>

                <Typography variant='caption' color='textSecondary'>{t('Quantity sold')}</Typography>
                <Typography variant='body2' gutterBottom>{quantity}</Typography>
                <Typography variant='caption' color='textSecondary'>
                    {t('Markup')}
                    <IncompleteDataDisclaimer productWithNoRecipeCount={productWithNoRecipeCount} />
                </Typography>
                <Typography variant='body2' gutterBottom>
                    {isNumber(netMargin)
                        ? priceService.toLocaleString(netMargin, currencyCode)
                        : t('N/A')}
                </Typography>

                <Typography variant='caption' color='textSecondary'>
                    {generateTranslationByVenueType({
                        translations: {
                            Restaurant: t('Food cost'),
                            Ecommerce: t('COGS')
                        },
                        venueType,
                    })}
                    <IncompleteDataDisclaimer productWithNoRecipeCount={productWithNoRecipeCount} />
                </Typography>
                <Typography variant='body2'>
                    {isNumber(foodCost)
                        ? `${priceService.fractionToPercent(foodCost, 2)}%`
                        : t('N/A')}
                </Typography>
            </CardContent>
        </ColoredCard>
    );
};

export default TopCategoryCard;
